import Vue from 'vue'
import Fuse from 'fuse.js'

// initial state
const state = {
  refCount: 0,
  // Current items - all or storage
  items: [],
  // All items from API
  all: [],
  // Items choose by user
  storage: [],
  // Is storage view
  is_storage: false,
  // Discount value
  discount: 0,
  //
  filtered_products: [],
  //
  locale: 'en',
  /***************************************************************************/
  products: [],
  filtered_categories: ['cat1','cat2'],
  filtered_products_count: 0,
  loading: true,
  listType: ''
}

// getters
const getters = {
  items: state => state.items,
  all: state => state.all,
  storage: state => state.storage,
  is_storage: state => state.is_storage,
  discount: state => state.discount,
  filtered_products: state => state.filtered_products,
  locale: state => state.locale,
  /***************************************************************************/
  filtered_categories: state => state.filtered_categories,
  filtered_categories_count: state => state.filtered_categories.length,
  filtered_products_count: state => state.filtered_products.length,
  loading: state => state.loading,
  products: state => state.products,
  listType: state => state.listType
}

// actions
const actions = {

    load_all_async ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('SET_LOADING', true)
          Vue.axios.get('pricelist', {
            params: {
              lang: state.locale,
              company: payload
            }
          })
          .then(response => response.data).then(all => {
            // console.log(all);
            commit('SET_LOADING', false)
            commit('SET_ALL', all)
            // resolve();
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
          resolve()
        }, 500)
      })
    },

    load_products_async ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('SET_LOADING', true)
          Vue.axios
            .get('pricelist/products', {
              params: {
                lang: state.locale,
                company: payload
              }
            })
            .then(r => r.data).then(products => {
              // console.log(products);
              commit('SET_PRODUCTS', products);
              commit('SET_LOADING', false)
            });
            resolve()
        }, 500)
      })
    },

    load_products_filtered ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const fuse = new Fuse(state.products, data.options);
        const results = fuse.search(data.query);
        commit('SET_FILTERED_PRODUCTS', results);
        resolve(results);
      });
    },

    switch_to_storage({ commit }) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('SWITCH_TO_STORAGE');
          commit('SET_IS_STORAGE', true);
          commit('SET_LOADING', false);
          resolve();
        }, 100);
      });

      // commit('SET_IS_STORAGE', true);
    },

    switch_to_all({ commit }) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('SWITCH_TO_ALL');
          commit('SET_IS_STORAGE', false);
          commit('SET_LOADING', false);
          resolve();
        }, 100);
      });


      // commit('SET_IS_STORAGE', false);
    },

    add_to_storage({ commit }, id) {
      commit('ADD_TO_STORAGE',id);
    },

    delete_from_storage({ commit }, category) {
      commit('DELETE_FROM_STORAGE',category);
    },

    set_discount({ commit }, value) {
      commit('SET_DISCOUNT', value);
    },

    set_locale({ commit }, value) {
      commit('SET_LOCALE', value);
    },
    /**************************************************************************/
    loadFilteredCategoriesAsync ({ commit }, data) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // commit('SET_LOADING', true) - not required because not reload results
          Vue.axios
            .get('pricelist/categories', {
              params: {
                query: data.query,
                lang: state.locale,
                company: data.company
              }
            })
            .then(r => {
              commit('SET_FILTERED_CATEGORIES', r.data)
            });
            resolve()
        }, 100)
      })
    },

    // Z API
    loadFilteredProductsAsync ({ commit }, data) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('SET_LOADING', true)
          Vue.axios
            .get('pricelist.php?query='+data.query)
            .then(r => {
              commit('SET_FILTERED_PRODUCTS', r.data.data);
              commit('SET_LOADING', false)
            });
            resolve()
        }, 100)
      })
    },



}

// mutations
const mutations = {

  SET_ITEMS (state, all) {
    state.items = all;
  },

  SET_ALL (state, all) {
    state.items = all;
    state.all = all;
  },

  SWITCH_TO_STORAGE (state) {
    state.items = state.storage;
  },

  SET_LISTTYPE (state, payload) {
    state.listType = payload
  },

  SWITCH_TO_ALL (state) {
    state.items = state.all;
  },

  ADD_TO_STORAGE (state, id) {
    state.storage.push(id);
  },

  DELETE_FROM_STORAGE (state, category) {

    // we have an array of objects, we want to remove one object using only the id property
    var removeIndex = state.storage.map(function(item) { return item.id; }).indexOf(category.id);
    // remove object
    state.storage.splice(removeIndex, 1);

    // state.storage = state.storage.filter(e => e !== category);
    // Dla ID:
    // let index = state.storage.indexOf(id);
    // if(index > -1) {
    //   let deleted = state.storage.splice(index, 1);
    //   console.log('DELETE_FROM_STORAGE done. Deleted ID: ', deleted);
    // }
  },

  SET_DISCOUNT(state, value) {
    state.discount = value;
  },

  SET_IS_STORAGE(state, value) {
    state.is_storage = value;
  },

  SET_LOCALE(state, value) {
    state.locale = value;
  },

  /***************************************************************************/

  SET_FILTERED_CATEGORIES (state, filtered_categories) {
    state.filtered_categories = filtered_categories;
  },

  SET_PRODUCTS (state, products) {
    state.products = products;
  },

  SET_FILTERED_PRODUCTS (state, filtered_products) {
    state.filtered_products = filtered_products;
  },

  SET_LOADING (state, loading) {
    state.loading = loading;
  },

  SET_LOADING (state, loading) {
    // console.log(loading)
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },

  REMOVE_PRODUCTS (state, products) {
    state.products = []
    state.items = []
    state.all = []
    state.storage = []
    state.is_storage = false
    state.discount = false
    state.filtered_products = []
    state.locale = 'pl'
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pricelist.js